// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"71c0b289","292":"c004881b","384":"c57525c3","584":"54648ef1","897":"401c13ff"}[chunkId] + ".chunk.css";
};